import { Chromosome } from "./Chromosome.js";
import { ChromosomeArm } from "./ChromosomeArm.js";
import type { ChromosomeLocation } from "./ChromosomeLocation.js";
import type { chromosomeArmShorthandNameMap } from "./names/chromosomeArmShorthandNameMap.js";

type Location =
	| [(typeof chromosomeArmShorthandNameMap)[ChromosomeArm.Centromere]]
	| [(typeof chromosomeArmShorthandNameMap)[ChromosomeArm.ShortArm | ChromosomeArm.LongArm], number, number]
	| [(typeof chromosomeArmShorthandNameMap)[ChromosomeArm.ShortArm | ChromosomeArm.LongArm], number, number, number];

const chromosomeLocationsPretty = {
	[Chromosome.C1]: [
		["p", 3, 6, 3],
		["p", 3, 6, 2],
		["p", 3, 6, 1],
		["p", 3, 5],
		["p", 3, 4, 3],
		["p", 3, 4, 2],
		["p", 3, 4, 1],
		["p", 3, 3],
		["p", 3, 2, 3],
		["p", 3, 2, 2],
		["p", 3, 2, 1],
		["p", 3, 1, 3],
		["p", 3, 1, 2],
		["p", 3, 1, 1],
		["p", 2, 2, 3],
		["p", 2, 2, 2],
		["p", 2, 2, 1],
		["p", 2, 1],
		["p", 1, 3, 3],
		["p", 1, 3, 2],
		["p", 1, 3, 1],
		["p", 1, 2],
		["c"],
		["q", 1, 2],
		["q", 2, 1],
		["q", 2, 2],
		["q", 2, 3, 1],
		["q", 2, 3, 2],
		["q", 2, 3, 3],
		["q", 2, 4],
		["q", 2, 5, 1],
		["q", 2, 5, 2],
		["q", 2, 5, 3],
		["q", 3, 1],
		["q", 3, 2, 1],
		["q", 3, 2, 2],
		["q", 3, 2, 3],
		["q", 4, 1],
		["q", 4, 2, 1],
		["q", 4, 2, 2],
		["q", 4, 2, 3],
		["q", 4, 3],
		["q", 4, 4],
	],
	[Chromosome.C2]: [
		["p", 2, 5, 3],
		["p", 2, 5, 2],
		["p", 2, 5, 1],
		["p", 2, 4],
		["p", 2, 3],
		["p", 2, 2],
		["p", 2, 1],
		["p", 1, 6],
		["p", 1, 5],
		["p", 1, 4],
		["p", 1, 3],
		["p", 1, 2],
		["p", 1, 1, 2],
		["c"],
		["q", 1, 1, 2],
		["q", 1, 2],
		["q", 1, 3],
		["q", 1, 4, 1],
		["q", 1, 4, 2],
		["q", 1, 4, 3],
		["q", 2, 1, 1],
		["q", 2, 1, 2],
		["q", 2, 1, 3],
		["q", 2, 2],
		["q", 2, 3],
		["q", 2, 4, 1],
		["q", 2, 4, 2],
		["q", 2, 4, 3],
		["q", 3, 1],
		["q", 3, 2, 1],
		["q", 3, 2, 2],
		["q", 3, 2, 3],
		["q", 3, 3],
		["q", 3, 4],
		["q", 3, 5],
		["q", 3, 6],
		["q", 3, 7, 1],
		["q", 3, 7, 2],
		["q", 3, 7, 3],
	],
	[Chromosome.C3]: [
		["p", 2, 6],
		["p", 2, 5],
		["p", 2, 4, 3],
		["p", 2, 4, 2],
		["p", 2, 4, 1],
		["p", 2, 3],
		["p", 2, 2],
		["p", 2, 1, 3],
		["p", 2, 1, 2],
		["p", 2, 1, 1],
		["p", 1, 4, 3],
		["p", 1, 4, 2],
		["p", 1, 4, 1],
		["p", 1, 3],
		["p", 1, 2],
		["p", 1, 1, 2],
		["c"],
		["q", 1, 1, 2],
		["q", 1, 2],
		["q", 1, 3, 1],
		["q", 1, 3, 2],
		["q", 1, 3, 3],
		["q", 2, 1],
		["q", 2, 2],
		["q", 2, 3],
		["q", 2, 4],
		["q", 2, 5, 1],
		["q", 2, 5, 2],
		["q", 2, 5, 3],
		["q", 2, 6, 1],
		["q", 2, 6, 2],
		["q", 2, 6, 3],
		["q", 2, 7],
		["q", 2, 8],
		["q", 2, 9],
	],
	[Chromosome.C4]: [
		["p", 1, 6, 3],
		["p", 1, 6, 2],
		["p", 1, 6, 1],
		["p", 1, 5, 3],
		["p", 1, 5, 2],
		["p", 1, 5, 1],
		["p", 1, 4],
		["p", 1, 3],
		["p", 1, 2],
		["c"],
		["q", 1, 2],
		["q", 1, 3, 1],
		["q", 1, 3, 2],
		["q", 1, 3, 3],
		["q", 2, 1, 1],
		["q", 2, 1, 2],
		["q", 2, 1, 3],
		["q", 2, 2],
		["q", 2, 3],
		["q", 2, 4],
		["q", 2, 5],
		["q", 2, 6],
		["q", 2, 7],
		["q", 2, 8],
		["q", 3, 1, 1],
		["q", 3, 1, 2],
		["q", 3, 1, 3],
		["q", 3, 2],
		["q", 3, 3],
		["q", 3, 4],
		["q", 3, 5],
	],
	[Chromosome.C5]: [
		["p", 1, 5, 3],
		["p", 1, 5, 2],
		["p", 1, 5, 1],
		["p", 1, 4],
		["p", 1, 3, 3],
		["p", 1, 3, 2],
		["p", 1, 3, 1],
		["p", 1, 2],
		["c"],
		["q", 1, 1, 2],
		["q", 1, 2],
		["q", 1, 3, 1],
		["q", 1, 3, 2],
		["q", 1, 3, 3],
		["q", 1, 4],
		["q", 1, 5],
		["q", 2, 1],
		["q", 2, 2],
		["q", 2, 3, 1],
		["q", 2, 3, 2],
		["q", 2, 3, 3],
		["q", 3, 1, 1],
		["q", 3, 1, 2],
		["q", 3, 1, 3],
		["q", 3, 2],
		["q", 3, 3, 1],
		["q", 3, 3, 2],
		["q", 3, 3, 3],
		["q", 3, 4],
		["q", 3, 5, 1],
		["q", 3, 5, 2],
		["q", 3, 5, 3],
	],
	[Chromosome.C6]: [
		["p", 2, 5],
		["p", 2, 4],
		["p", 2, 3],
		["p", 2, 2, 3],
		["p", 2, 2, 2],
		["p", 2, 2, 1],
		["p", 2, 1, 3],
		["p", 2, 1, 2],
		["p", 2, 1, 1],
		["p", 1, 2],
		["p", 1, 1, 2],
		["c"],
		["q", 1, 2],
		["q", 1, 3],
		["q", 1, 4],
		["q", 1, 5],
		["q", 1, 6, 1],
		["q", 1, 6, 2],
		["q", 1, 6, 3],
		["q", 2, 1],
		["q", 2, 2, 1],
		["q", 2, 2, 2],
		["q", 2, 2, 3],
		["q", 2, 3, 1],
		["q", 2, 3, 2],
		["q", 2, 3, 3],
		["q", 2, 4],
		["q", 2, 5, 1],
		["q", 2, 5, 2],
		["q", 2, 5, 3],
		["q", 2, 6],
		["q", 2, 7],
	],
	[Chromosome.C7]: [
		["p", 2, 2],
		["p", 2, 1],
		["p", 1, 5, 3],
		["p", 1, 5, 2],
		["p", 1, 5, 1],
		["p", 1, 4],
		["p", 1, 3],
		["p", 1, 2],
		["p", 1, 1, 2],
		["c"],
		["q", 1, 1, 21],
		["q", 1, 1, 22],
		["q", 1, 1, 23],
		["q", 2, 1, 1],
		["q", 2, 1, 2],
		["q", 2, 1, 3],
		["q", 2, 2],
		["q", 3, 1, 1],
		["q", 3, 1, 2],
		["q", 3, 1, 3],
		["q", 3, 2],
		["q", 3, 3],
		["q", 3, 4],
		["q", 3, 5],
		["q", 3, 6],
	],
	[Chromosome.C8]: [
		["p", 2, 3, 3],
		["p", 2, 3, 2],
		["p", 2, 3, 1],
		["p", 2, 2],
		["p", 2, 1, 3],
		["p", 2, 1, 2],
		["p", 2, 1, 1],
		["p", 1, 2],
		["p", 1, 1, 2],
		["c"],
		["q", 1, 1, 21],
		["q", 1, 1, 22],
		["q", 1, 1, 23],
		["q", 1, 2],
		["q", 1, 3],
		["q", 2, 1, 1],
		["q", 2, 1, 2],
		["q", 2, 1, 3],
		["q", 2, 2, 1],
		["q", 2, 2, 2],
		["q", 2, 2, 3],
		["q", 2, 3],
		["q", 2, 4, 1],
		["q", 2, 4, 21],
		["q", 2, 4, 22],
		["q", 2, 4, 23],
		["q", 2, 4, 3],
	],
	[Chromosome.C9]: [
		["p", 2, 4],
		["p", 2, 3],
		["p", 2, 2],
		["p", 2, 1],
		["p", 1, 3],
		["p", 1, 2],
		["c"],
		["q", 1, 2],
		["q", 1, 3],
		["q", 2, 1, 1],
		["q", 2, 1, 2],
		["q", 2, 1, 3],
		["q", 2, 2, 1],
		["q", 2, 2, 2],
		["q", 2, 2, 3],
		["q", 3, 1],
		["q", 3, 2],
		["q", 3, 3],
		["q", 3, 4, 1],
		["q", 3, 4, 2],
		["q", 3, 4, 3],
	],
	[Chromosome.C10]: [
		["p", 1, 5],
		["p", 1, 4],
		["p", 1, 3],
		["p", 1, 2, 3],
		["p", 1, 2, 2],
		["p", 1, 2, 1],
		["p", 1, 1, 2],
		["c"],
		["q", 1, 1, 2],
		["q", 2, 1, 1],
		["q", 2, 1, 2],
		["q", 2, 1, 3],
		["q", 2, 2, 1],
		["q", 2, 2, 2],
		["q", 2, 2, 3],
		["q", 2, 3, 1],
		["q", 2, 3, 2],
		["q", 2, 3, 3],
		["q", 2, 4, 1],
		["q", 2, 4, 2],
		["q", 2, 4, 3],
		["q", 2, 5, 1],
		["q", 2, 5, 2],
		["q", 2, 5, 3],
		["q", 2, 6, 1],
		["q", 2, 6, 2],
		["q", 2, 6, 3],
	],
	[Chromosome.C11]: [
		["p", 1, 5, 5],
		["p", 1, 5, 4],
		["p", 1, 5, 3],
		["p", 1, 5, 2],
		["p", 1, 5, 1],
		["p", 1, 4],
		["p", 1, 3],
		["p", 1, 2],
		["p", 1, 1, 2],
		["p", 1, 1, 12],
		["c"],
		["q", 1, 2],
		["q", 1, 3, 1],
		["q", 1, 3, 2],
		["q", 1, 3, 3],
		["q", 1, 3, 4],
		["q", 1, 3, 5],
		["q", 1, 4, 1],
		["q", 1, 4, 2],
		["q", 1, 4, 3],
		["q", 2, 1],
		["q", 2, 2, 1],
		["q", 2, 2, 2],
		["q", 2, 2, 3],
		["q", 2, 3, 1],
		["q", 2, 3, 2],
		["q", 2, 3, 3],
		["q", 2, 4, 1],
		["q", 2, 4, 2],
		["q", 2, 4, 3],
		["q", 2, 5],
	],
	[Chromosome.C12]: [
		["p", 1, 3, 3],
		["p", 1, 3, 2],
		["p", 1, 3, 1],
		["p", 1, 2, 3],
		["p", 1, 2, 2],
		["p", 1, 2, 1],
		["p", 1, 1, 2],
		["c"],
		["q", 1, 2],
		["q", 1, 3, 1],
		["q", 1, 3, 2],
		["q", 1, 3, 3],
		["q", 1, 4],
		["q", 1, 5],
		["q", 2, 1, 1],
		["q", 2, 1, 2],
		["q", 2, 1, 3],
		["q", 2, 2],
		["q", 2, 3],
		["q", 2, 4, 1],
		["q", 2, 4, 2],
		["q", 2, 4, 31],
		["q", 2, 4, 32],
		["q", 2, 4, 33],
	],
	[Chromosome.C13]: [
		["p", 1, 3],
		["p", 1, 2],
		["p", 1, 1, 2],
		["c"],
		["q", 1, 2, 1],
		["q", 1, 2, 2],
		["q", 1, 2, 3],
		["q", 1, 3],
		["q", 1, 4, 1],
		["q", 1, 4, 2],
		["q", 1, 4, 3],
		["q", 2, 1, 1],
		["q", 2, 1, 2],
		["q", 2, 1, 3],
		["q", 2, 2],
		["q", 3, 1],
		["q", 3, 2],
		["q", 3, 3],
		["q", 3, 4],
	],
	[Chromosome.C14]: [
		["p", 1, 3],
		["p", 1, 2],
		["p", 1, 1, 2],
		["c"],
		["q", 1, 1, 2],
		["q", 1, 2],
		["q", 1, 3],
		["q", 2, 1],
		["q", 2, 2],
		["q", 2, 3],
		["q", 2, 4, 1],
		["q", 2, 4, 2],
		["q", 2, 4, 3],
		["q", 3, 1],
		["q", 3, 2, 1],
		["q", 3, 2, 2],
		["q", 3, 2, 3],
	],
	[Chromosome.C15]: [
		["p", 1, 3],
		["p", 1, 2],
		["p", 1, 1, 2],
		["c"],
		["q", 1, 1, 2],
		["q", 1, 2],
		["q", 1, 3],
		["q", 1, 4],
		["q", 1, 5],
		["q", 2, 1, 1],
		["q", 2, 1, 2],
		["q", 2, 1, 3],
		["q", 2, 2, 1],
		["q", 2, 2, 2],
		["q", 2, 2, 3],
		["q", 2, 3],
		["q", 2, 4],
		["q", 2, 5],
		["q", 2, 6, 1],
		["q", 2, 6, 2],
		["q", 2, 6, 3],
	],
	[Chromosome.C16]: [
		["p", 1, 3, 3],
		["p", 1, 3, 2],
		["p", 1, 3, 1],
		["p", 1, 2],
		["p", 1, 1, 2],
		["c"],
		["q", 1, 1, 2],
		["q", 1, 2, 1],
		["q", 1, 2, 2],
		["q", 1, 3],
		["q", 2, 1],
		["q", 2, 2],
		["q", 2, 3],
		["q", 2, 4],
	],
	[Chromosome.C17]: [
		["p", 1, 3],
		["p", 1, 2],
		["p", 1, 1, 2],
		["c"],
		["q", 1, 1, 2],
		["q", 1, 2],
		["q", 2, 1, 1],
		["q", 2, 1, 2],
		["q", 2, 1, 3],
		["q", 2, 2],
		["q", 2, 3],
		["q", 2, 4],
		["q", 2, 5],
	],
	[Chromosome.C18]: [
		["p", 1, 1, 32],
		["p", 1, 1, 31],
		["p", 1, 1, 2],
		["c"],
		["q", 1, 1, 2],
		["q", 1, 2, 1],
		["q", 1, 2, 2],
		["q", 1, 2, 3],
		["q", 2, 1, 1],
		["q", 2, 1, 2],
		["q", 2, 1, 3],
		["q", 2, 2],
		["q", 2, 3],
	],
	[Chromosome.C19]: [
		["p", 1, 3, 3],
		["p", 1, 3, 2],
		["p", 1, 3, 1],
		["p", 1, 2],
		["c"],
		["q", 1, 2],
		["q", 1, 3, 1],
		["q", 1, 3, 2],
		["q", 1, 3, 3],
		["q", 1, 3, 4],
	],
	[Chromosome.C20]: [
		["p", 1, 3],
		["p", 1, 2],
		["p", 1, 1, 2],
		["c"],
		["q", 1, 1, 2],
		["q", 1, 2],
		["q", 1, 3, 1],
		["q", 1, 3, 2],
		["q", 1, 3, 3],
	],
	[Chromosome.C21]: [
		["p", 1, 3],
		["p", 1, 2],
		["p", 1, 1, 2],
		["c"],
		["q", 1, 1, 2],
		["q", 2, 1],
		["q", 2, 2, 1],
		["q", 2, 2, 2],
		["q", 2, 2, 3],
	],
	[Chromosome.C22]: [
		["p", 1, 3],
		["p", 1, 2],
		["p", 1, 1, 2],
		["c"],
		["q", 1, 1, 2],
		["q", 1, 2, 1],
		["q", 1, 2, 2],
		["q", 1, 2, 3],
		["q", 1, 3, 1],
		["q", 1, 3, 2],
		["q", 1, 3, 3],
	],
	[Chromosome.X]: [
		["p", 2, 2, 33],
		["p", 2, 2, 32],
		["p", 2, 2, 31],
		["p", 2, 2, 2],
		["p", 2, 2, 1],
		["p", 2, 1, 3],
		["p", 2, 1, 2],
		["p", 2, 1, 1],
		["p", 1, 1, 4],
		["p", 1, 1, 3],
		["p", 1, 1, 23],
		["p", 1, 1, 22],
		["p", 1, 1, 21],
		["c"],
		["q", 1, 1, 2],
		["q", 1, 2],
		["q", 1, 3],
		["q", 2, 1, 1],
		["q", 2, 1, 2],
		["q", 2, 1, 3],
		["q", 2, 2, 1],
		["q", 2, 2, 2],
		["q", 2, 2, 3],
		["q", 2, 3],
		["q", 2, 4],
		["q", 2, 5],
		["q", 2, 6],
		["q", 2, 7],
		["q", 2, 8],
	],
	[Chromosome.Y]: [
		["p", 1, 1, 32],
		["p", 1, 1, 31],
		["p", 1, 2],
		["c"],
		["q", 1, 1, 21],
		["q", 1, 1, 221],
		["q", 1, 1, 222],
		["q", 1, 1, 223],
		["q", 1, 1, 23],
		["q", 1, 2],
	],
} satisfies Record<Chromosome, Location[]>;

export const chromosomeLocations: Omit<ChromosomeLocation, "color">[] = Object.values(Chromosome).flatMap(
	(chromosome) => {
		const locations = chromosomeLocationsPretty[chromosome];
		return locations.map((location) => {
			if (location[0] === "c") {
				return {
					chromosome,
					arm: ChromosomeArm.Centromere,
				};
			}
			return {
				chromosome,
				arm: {
					p: ChromosomeArm.ShortArm,
					q: ChromosomeArm.LongArm,
				}[location[0]],
				region: location[1],
				band: location[2],
				subBand: location[3],
			};
		});
	},
);
